// "use client"
// import React from 'react';
// import CustomBtn from './HoverBtn'
// // import BackgroundVideo from 'next-video/background-video';

// export const HeroSection = () => {
//   const BlurVideoImage = 'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575804/blurheroImg_hocfzy.webp'

//   const awesomeVideo = 'https://res.cloudinary.com/dcwai4hwc/video/upload/v1729580491/get-started_iyzpzb.mp4'
//   return (
//     <div className="w-full h-[100vh] overflow-hidden relative">
//   <video 
//     src={awesomeVideo}
//     autoPlay
//     loop
//     muted 
//     className="absolute top-0 left-0 w-full h-full object-cover z-0"
//   />
//   <div className="absolute top-0 left-0 w-full h-full bg-black opacity-0 z-5"></div> {/* Overlay for readability */}
//   <div className="flex flex-col justify-center items-center h-full relative z-10 pt-20">
//     <span className="text-[#F3F4F6] text-4xl md:text-5xl text-center font-bold">Leading Software Solutions for Your Business</span>
//     <span className="text-[#F3F4F6] mt-4 text-xl font-semibold sm:font-bold md:text-2xl text-center capitalize">
//       We provide innovative software solutions tailored to your business needs, enhancing efficiency and productivity.
//     </span>
//     <div className=" md:text-4xl text-neutral-200 py-4 flex justify-center gap-8 relative z-10">
//     <span className="text-center text-sm md:text-md font-semibold text-white capitalize">
//       <span className="md:border-t-2 border-[#000b43] block sm:inline">We Help</span> Global Brands Succeed
//     </span>
//     <span className="text-center text-sm md:text-md font-semibold text-white capitalize">
//       <span className="md:border-t-2 border-[#000b43] block sm:inline">These Values</span> Are Essential to Our Mission
//     </span>
//   </div>
//   <CustomBtn />

//   </div>

// </div>

//   );
// };

// old code version 01 
// import React from 'react';
// import CustomBtn from './HoverBtn'
// import BackgroundVideo from 'next-video/background-video';
// import loadingBg from '../../../public/loading_bg.PNG'
//  const HeroSection = () => {
//   // const BlurVideoImage = 'https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575804/blurheroImg_hocfzy.webp'
//   // const awesomeVideo = 'https://res.cloudinary.com/dcwai4hwc/video/upload/v1729580491/get-started_iyzpzb.mp4'
//   return (
//     <div className="video-background-container relative w-full h-[100vh] overflow-hidden">
//       <BackgroundVideo src={'/nubit_video.mp4'}
//         poster={loadingBg}
//         className=" w-full h-[100vh]"
//         >
//         <div className="flex flex-col justify-center items-center pt-24">
//           <span className="text-[#F3F4F6] text-4xl md:text-7xl text-center font-bold bg-black/50 sm:pb-3 rounded-md sm:px-3 bg-opacity-60">Leading Software Solutions for Your Business</span>
//           <span className="text-[#F3F4F6] mt-6 text-xl font-semibold sm:font-bold md:text-2xl text-center capitalize bg-black/50 p-2 rounded-md  bg-opacity-60">We provide innovative software solutions tailored to your business needs,enhancing efficiently and productivity</span>
//         </div>
//         <div
//             className=" text-base md:text-4xl dark:text-neutral-200 py-4 flex justify-center   gap-8 ">
//             <span className="text-center text-sm md:text-md font-semibold text-white capitalize bg-black/50 py-1 rounded-md px-3 bg-opacity-60">
//               <span className="md:border-t-2 border-[000b43] block sm:inline ">We Help</span> Global Brands Succeed
//             </span>
//             <span className="text-center  text-sm md:text-md font-semibold text-white capitalize bg-black/50 py-1 rounded-md px-3 bg-opacity-60">
//               <span className="md:border-t-2 border-[000b43] block sm:inline">These Values</span> Are Essential to Our Mission
//             </span>
//           </div> 
//              <CustomBtn />
//       </BackgroundVideo>

//     </div>
//   );
// };
// export default HeroSection




// 2 
"use client"
import React, { useState } from "react";
import CustomBtn from "./HoverBtn";
import loadingBg from "../../../public/loading_bg.PNG";

const HeroSection = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);
  return (
    <div className="relative w-full h-[100vh] overflow-hidden">

      {!videoLoaded && (
        <img
          src={loadingBg.src}
          alt="loading"
          className={`absolute top-0 left-0 w-full h-full 
object-contain md:object-cover 
transition-opacity duration-700 `}
        />
      )}

      {/* Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        onLoadedData={() => {
          if (!videoLoaded) setVideoLoaded(true);
        }}
        controlsList="nodownload"
        className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-700 ${videoLoaded ? "opacity-100" : "opacity-100"}`}
      >
        <source src="https://res.cloudinary.com/dsvbvqa5m/video/upload/v1785140579/nubit_video_v3lwwx.mp4" type="video/mp4" />
      </video>
      {/* <video
        autoPlay
        muted
        loop
        playsInline
        poster={loadingBg.src}
        className="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source src="/nubit_video.mp4" type="video/mp4" />
      </video> */}

      {/* readability scrim */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black/80 z-[1]" />

      {/* <div className="relative z-10 flex flex-col justify-center items-center pt-24"> */}
      <div className="relative z-10 flex flex-col justify-center items-center h-full px-4 text-center gap-6">
        {/* <span className="eyebrow pill-chip">Custom Software &middot; Web &middot; Mobile &middot; BPO</span> */}

        <span className="text-[#F3F4F6] text-3xl sm:text-4xl md:text-6xl text-center font-bold leading-tight max-w-4xl">
          Leading Software Solutions for Your Business
        </span>

        <span className="text-slate-200 max-w-2xl text-lg md:text-xl text-center leading-relaxed">
          We provide innovative software solutions tailored to your business
          needs, enhancing efficiency and productivity
        </span>

        <div className="text-base py-2 flex flex-wrap justify-center gap-4">
          <span className="pill-chip text-xs md:text-sm font-semibold">
            <span className="block sm:inline">
              We Help
            </span>{" "}
            Global Brands Succeed
          </span>

          <span className="pill-chip text-xs md:text-sm font-semibold">
            <span className="block sm:inline">
              These Values
            </span>{" "}
            Are Essential to Our Mission
          </span>
        </div>

        <CustomBtn />
      </div>
    </div>
  );
};

export default HeroSection;